import React from 'react'
import CollectionGallery from '../components/CollectionGallery'

const BoysCollection: React.FC = () => {
  return <CollectionGallery collection="boys" />
}

export default BoysCollection
